import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { SettingsComponent } from '../../pages/settings/settings.component';
import { UIModule } from '../../ui/ui.module';
import { IconsProviderModule } from '../../icons-provider.module';
import { FrameModule } from '../../global-components/frame/frame.module';
import { NzShareModule } from '../../nz/nz-share.module';
import { CommonModule } from '@angular/common';

const routes: Routes = [
  { path: '', component: SettingsComponent }
];

@NgModule({
  declarations: [
    SettingsComponent,
  ],
  exports: [
  ],
  imports: [
    CommonModule,
    UIModule,
    FormsModule,
    IconsProviderModule,
    NzShareModule,
    FrameModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes)
  ],
  bootstrap: []
})
export class SettingsModule {}
